import { trackEvent } from '../../../utils/tracking';
import mixpanel from 'mixpanel-browser';

// Define the step mapping
const stepBackMap = {
  1.5: 1,
  2: 1,
  2.5: 2,
  3: 2,
  4: 3,
};

// Handle financing choice
const handleFinancingChoice = async (choice, setStep, setHasFinancing) => {
  try {
    mixpanel.track('Financing Choice', { choice: choice ? 'Yes' : 'No' });
  } catch (error) {
    console.error('Client-side tracking failed:', error);
    await trackEvent('Financing Choice', { choice: choice ? 'Yes' : 'No' });
  }
  setHasFinancing(choice);
  if (choice) {
    setStep(2);
  } else {
    setStep(1.5);
  }
};

// Handle found home choice
const handleFoundHomeChoice = async (choice, setStep, setFoundHome) => {
  try {
    mixpanel.track('Found Home Choice', { choice: choice ? 'Yes' : 'No' });
  } catch (error) {
    console.error('Client-side tracking failed:', error);
    await trackEvent('Found Home Choice', { choice: choice ? 'Yes' : 'No' });
  }
  setFoundHome(choice);
  if (choice) {
    setStep(2.5);
  } else {
    setStep(3);
  }
};

// Handle priority choice
const handlePriorityChoice = async (choice, setStep, setPriority) => {
  try {
    mixpanel.track('Priority Choice', { priority: choice });
  } catch (error) {
    console.error('Client-side tracking failed:', error);
    await trackEvent('Priority Choice', { priority: choice });
  }
  setPriority(choice);
  setStep(4);
};

// Handle back navigation
const handleBack = (currentStep, setStep, resetFunctions = {}) => {
  const prevStep = stepBackMap[currentStep];
  if (prevStep) {
    setStep(prevStep);
    // Reset state variables if needed
    if (currentStep === 2.5 && resetFunctions.resetFoundHome) {
      resetFunctions.resetFoundHome();
    }
    if (currentStep === 3 && resetFunctions.resetPriority) {
      resetFunctions.resetPriority();
    }
    // Add more conditions if other steps require resetting
  }
};

// Handle explore action
const handleExploreSignUp = async (currentStep, navigate) => {
  try {
    mixpanel.track('Sign Up Button Clicked', { step: currentStep });
  } catch (error) {
    console.error('Client-side tracking failed:', error);
    await trackEvent('Sign Up Button Clicked', { step: currentStep });
  }
  navigate('/walkthrough/signup');
};

const handleExploreApp = async (currentStep, navigate) => {
  try {
    mixpanel.track('Explore Button Clicked', { step: currentStep });
  } catch (error) {
    console.error('Client-side tracking failed:', error);
    await trackEvent('Explore Button Clicked', { step: currentStep });
  }
  navigate('/app');
};

// Export all functions
export {
  handleFinancingChoice,
  handleFoundHomeChoice,
  handlePriorityChoice,
  handleBack,
  handleExploreSignUp,
  handleExploreApp
};